export default "__VITE_ASSET__BnP3WcDU__"